import React, { useEffect, useMemo, useRef, useState } from "react"; import { Field, FormikProvider, Form, useFormik } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App"; import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import { Container, Row, Col, Button, Modal,Tab,Nav } from 'react-bootstrap'; import { MdOutlinePictureAsPdf } from "react-icons/md";
import {  allowNumberswithMaxLengthcatidtypeOnly, allowNumberswithMaxLengthtypeOnly, convertFormattedToPlainNumber, exportToentryExcel,formatNumberIndianWithDecimal, generateentryPdf} from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService";import { FaExclamationTriangle, FaRegSave } from "react-icons/fa"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert";
 import { Alert } from "@mui/material"

export default function TargetsEntry() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [buttontype, setButtontype] = useState(""); const [distEnb, setDistEnb] = useState(false); const [distlist, setDistrictList] = useState(); const [alertenb, setalertenb] = useState(false); const [Entryenb, setEntryEnb] = useState(false);  const[showModal,setshowModal] = useState(false); const[disablee,setdisablee] = useState(false); const[buttonenb,setbuttonenb] = useState(); let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let district = localStorage.getItem("districtid"); let deptId = localStorage.getItem("deptid"); const [enbSub, setEnbSub] = useState(false); const [activeTab, setActiveTab] = useState('HOD'); const [container, setContainer] = useState(false); const [searchText, setSearch] = useState(""); const [districts, setDistricts] = React.useState([]); const [mandals, setmandals] = React.useState([]); const [indicatorsList, setIndicatorsList] = React.useState([]); const [menuEntry, setMenuEntry] = useState(null); const [maxLen, setMaxlen] = useState(); let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); const [Deptlist, setDeptlist] = useState([]); const [updateenb,setupdateenb] = useState(); const [seqid,setseqid] = useState();const [year,setyear] = useState(); const [statusId,setstatusId] = useState();
const[statuscheck,setstatuscheck]= useState();const [entry_type, setentry_type] = useState("");
  const restrictToPasteOnlyEightDotThreeAllowKeyPress = (formik,type, fieldName, index) => ({
  onPaste: (e) => {
    e.preventDefault(); const pasted = e.clipboardData.getData("text").trim(); const regex = /^\d{1,8}(\.\d{1,3})?$/;
    if (regex.test(pasted)) {
if (type === "HOD") { formik.setFieldValue(`Indicators[${index}].${fieldName}`, pasted); } else { formik.setFieldValue(fieldName, pasted); }
    } else {
      showAlertMessage("Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ","warning");
    }
  },
});

const restrictToPasteOnlyEightDotcommaThreeAllowKeyPress = (formik, type, fieldName, index) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim(); const pastedClean = pasted.replace(/,/g, ""); const regex = /^\d{1,8}(\.\d{1,3})?$/;

    if (regex.test(pastedClean)) {
      const formatted = formatNumberIndianWithDecimal(pastedClean);
      if (type === "HOD") {
        formik.setFieldValue(`Indicators[${index}].${fieldName}`, formatted);
      } else {
        formik.setFieldValue(fieldName, formatted);
      }
    } else {
      showAlertMessage("Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed.","warning");
    }
  },
});

useEffect(() => {
    const entry = localStorage.getItem("selectedMenuEntry");
    if (entry) {
      setMenuEntry(entry);
    }
  }, []);
  const formik = useFormik({
    initialValues: {
      userId: "", district_id: "",department_id:"", mandal_id: "",year:"", Indicators: [{ indicator_id: "", entry_value: "",unit:"",indicator_name:"",unit_name:"",numerator:"",denominator:"",no_of_columns:"",multiplir:"",devider:"",status_id:"",ind_type:""}], forward: "", forward_to: "", role_id: "",
    DistIndicators: [{ indicator_id: "", entry_value: "",unit:"",district:"",mandal:"",indicator_name:"",unit_name:"",numerator:"",denominator:"",multiplir:"",devider:"",totals:"",total:"",status_id:"",ind_type:""}],
    MandalIndicators: [{ indicator_id: "", entry_value: "",unit:"",indicator_name:"",unit_name:"",numerator:"",denominator:"",multiplir:"",devider:"",total:"",status_id:"",ind_type:""}],

    },
    onSubmit: (values) => { }
  })
 const handleInputChange = (e, index, fieldName, type) => { const value = e.target.value.trim(); let sanitizedValue = ''; for (let i = 0; i < value.length; i++) { const char = value[i]; if (char !== ',' && char !== '.') { sanitizedValue += char; } } const numericValue = parseFloat(sanitizedValue); if (value && !isNaN(numericValue) && numericValue === 0) { showAlertMessage( "Please Enter if only the Indicator is present at your area!", "warning", () => { if (type === "HOD") { formik.setFieldValue(`Indicators[${index}].${fieldName}`, ""); } else { formik.setFieldValue(fieldName, ""); } } ); } };

 const [Yearlist, setYearlist] = useState();
  useEffect(()=>{
     MasterService.getfinTargetyears().then((finachievres) => {
      if (finachievres.data) {
         let options = finachievres.data.map((item, i) => {
            return ( <option key={i} value={item.id}> {item.value} </option> );
          });
           setYearlist(options);
        }
      });
    if(roleid === "32"|| roleid === "2" || roleid === "60"|| roleid === "5"){
      formik.setFieldValue("department_id",deptId);
    }
   
    MasterService.getDistricts().then((res17) => { if (res17.data) { let options = res17.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setDistrictList(options); } });

    let paramss={
          userId:username
        }
    MasterService.getDeptartments(paramss).then((res) => {
        if (res.data) {
          let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); });
          setDeptlist(options);
        }
      });
   
    // if(roleid === "60"|| roleid === "5") {
    //   HodentryEnb('HOD',deptId);
    //  }

    if(!["8","5","60","5","32","2"].includes(roleid)){
    let params={ deptId:roleid === "8" ? formik.values.department_id:deptId, userId:username, 
      ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:"HOD"} : {} }
    formik.setFieldValue("Indicators",[])
    KpiService.getTargetEntrylist(params).
    then((res)=>{
      if (res.data.SCODE === "01") {
res.data.SDESC.forEach((item,i)=>{ formik.setFieldValue(`Indicators[${i}].indicator_id`,item.indicator_id); formik.setFieldValue(`Indicators[${i}].unit`,item.unit_id) })
 

}
else{
  showAlertMessage(res.data?.SDESC,"warning",()=>{
    setEntryEnb(false);
  });
}
})
    }
 if(roleid === "32" || roleid === "2"){
  formik.setFieldValue("district_id", district); setDistEnb(true); setEntryEnb(true);
      // TableData(district);
    }
  },[])



const prevIndicatorsRef = useRef([]);

// useEffect(() => {
//   if (!alertenb) {
//     if (!formik.values?.MandalIndicators || !mandals?.length || !indicatorsList?.length) return;

//     let lastIndicatorWithoutTarget = null;

//     const updatedIndicators = formik.values.MandalIndicators.map((indicator, i) => {
//       const newIndicator = { ...indicator };
//       const unitCatId = indicator.unit_cat_id;

//       mandals.forEach((mandal) => {
//         const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
//           ? mandal.ulb_code
//           : mandal.mandal_code;
//         const rawValue = indicator[`entry_${code}`];
//         newIndicator[`entry_${code}`] =
//           rawValue === 0 || rawValue === "0"
//             ? "0"
//             : rawValue === "" || rawValue == null
//             ? ""
//             : rawValue.toString();
//       });

//       const allMandalValues = mandals.map((mandal) => {
//         const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
//           ? mandal.ulb_code
//           : mandal.mandal_code;
//         const rawVal = newIndicator[`entry_${code}`];

//         if (unitCatId === 1) {
//           const plainVal = convertFormattedToPlainNumber(rawVal);
//           if (isNaN(plainVal) || plainVal === "") return null;
//           return parseFloat(Number(plainVal).toFixed(3));
//         } else {
//           const val = parseFloat(rawVal);
//           return isNaN(val) ? null : val;
//         }
//       });

//       let total = "";
//       if (unitCatId === 1) {
//         total = allMandalValues.reduce((sum, val) => sum + (val ?? 0), 0);
//         total = parseFloat(total).toFixed(3);
//       } else {
//         total = "-";
//       }

//       newIndicator.total = total;

//       const rawDistTarget = indicatorsList[i]?.district_target_2025;
//       const distTarget =
//         rawDistTarget === null || rawDistTarget === "" ? 0 : convertFormattedToPlainNumber(rawDistTarget);
//       const totalVal = parseFloat(convertFormattedToPlainNumber(total || "0"));

//       // Store last indicator without target but has values
//       if (distTarget === 0) {
//         const hasAnyEntry = mandals.some((mandal) => {
//           const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
//             ? mandal.ulb_code
//             : mandal.mandal_code;
//           const value = newIndicator[`entry_${code}`];
//           return value !== "" && value !== "0" && value !== null && value !== undefined;
//         });

//         if (hasAnyEntry) {
//           lastIndicatorWithoutTarget = {
//             index: i,
//             name: indicatorsList[i]?.indicator_name,
//           };
//         }
//       }

//       // Existing district target exceed check
//       if (unitCatId === 1) {
//         if (!isNaN(distTarget) && !isNaN(totalVal) && (distTarget === 0 ? totalVal > 0 : totalVal > distTarget)) {
//           let changedCode = "";
//           for (let j = 0; j < mandals.length; j++) {
//             const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
//               ? mandals[j].ulb_code
//               : mandals[j].mandal_code;
//             const prevVal = prevIndicatorsRef.current[i]?.[`entry_${code}`];
//             const currentVal = newIndicator[`entry_${code}`];
//             if (prevVal !== currentVal) {
//               changedCode = code;
//               break;
//             }
//           }

//           if (changedCode) {
//             showAlertMessage(
//               `Total for Indicator "${indicatorsList[i]?.indicator_name}" exceeds District Target (${distTarget}).`,
//               "warning",
//               () => {
//                 formik.setFieldValue(`MandalIndicators[${i}].entry_${changedCode}`, "");

//                 const correctedValues = mandals.map((mandal) => {
//                   const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
//                     ? mandal.ulb_code
//                     : mandal.mandal_code;
//                   if (code === changedCode) return null;
//                   const rawVal = newIndicator[`entry_${code}`];
//                   if (unitCatId === 1) {
//                     const plainVal = convertFormattedToPlainNumber(rawVal);
//                     if (isNaN(plainVal) || plainVal === "") return null;
//                     return parseFloat(Number(plainVal).toFixed(3));
//                   } else {
//                     const val = parseFloat(rawVal);
//                     return isNaN(val) ? null : val;
//                   }
//                 });

//                 let correctedTotal = "";
//                 if (unitCatId === 1) {
//                   correctedTotal = correctedValues.reduce((sum, val) => sum + (val ?? 0), 0);
//                   correctedTotal = parseFloat(correctedTotal).toFixed(3);
//                   formik.setFieldValue(`MandalIndicators[${i}].total`, formatNumberIndianWithDecimal(correctedTotal));
//                 }
//               }
//             );
//           }
//         }
//       }

//       return newIndicator;
//     });

//     // Show alert only for last indicator without target but has values
//     if (lastIndicatorWithoutTarget) {
//       const { index, name } = lastIndicatorWithoutTarget;
//       showAlertMessage(
//         `Entry not allowed for Indicator "${name}" as no target has been assigned by the HOD.`,
//         "warning",
//         () => {
//           mandals.forEach((mandal) => {
//             const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
//               ? mandal.ulb_code
//               : mandal.mandal_code;
//             formik.setFieldValue(`MandalIndicators[${index}].entry_${code}`, "");
//           });
//         }
//       );
//     }

//     let hasChanged = false;
//     for (let i = 0; i < updatedIndicators.length; i++) {
//       if (formik.values.MandalIndicators[i]?.total !== updatedIndicators[i]?.total) {
//         hasChanged = true;
//         break;
//       }
//     }

//     if (hasChanged) {
//       formik.setFieldValue("MandalIndicators", updatedIndicators);
//     }

//     prevIndicatorsRef.current = JSON.parse(JSON.stringify(updatedIndicators));
//   }
// }, [formik.values.MandalIndicators, mandals, indicatorsList]);


// Place this ref above your useEffect so it persists between renders

const hasShownNoTargetAlertRef = useRef(false);

useEffect(() => {
  if (container) return;
  if (!formik.values?.MandalIndicators || !mandals?.length || !indicatorsList?.length) return;

  let changedIndicatorIndex = null;
  let changedCode = null;


  for (let i = 0; i < formik.values.MandalIndicators.length; i++) {
    const indicator = formik.values.MandalIndicators[i];
    const prevIndicator = prevIndicatorsRef.current?.[i];

    if (!prevIndicator) continue;

    for (let m = 0; m < mandals.length; m++) {
      const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
        ? mandals[m].ulb_code
        : mandals[m].mandal_code;

      if (indicator[`entry_${code}`] !== prevIndicator[`entry_${code}`]) {
        changedIndicatorIndex = i;
        changedCode = code;
        break;
      }
    }

    if (changedIndicatorIndex !== null) break;
  }

  // === If a value was entered, check target ===
  if (changedIndicatorIndex !== null) {
    const rawDistTarget = indicatorsList[changedIndicatorIndex]?.district_target_2025;
    const distTarget =
      rawDistTarget === null || rawDistTarget === "" ? 0 : convertFormattedToPlainNumber(rawDistTarget);

    // This indicator has NO target
    if (distTarget === 0) {
      const newVal = formik.values.MandalIndicators[changedIndicatorIndex][`entry_${changedCode}`];
      if (newVal !== "" && newVal !== "0" && newVal !== null && newVal !== undefined) {
        showAlertMessage(
          `Entry not allowed for Indicator "${indicatorsList[changedIndicatorIndex]?.indicator_name}" as no target has been assigned by the HOD.`,
          "warning",
          () => {
            formik.setFieldValue(`MandalIndicators[${changedIndicatorIndex}].entry_${changedCode}`, "");
          }
        );
        return; // stop here, don't process totals
      }
    }
  }

  // === Process totals and target exceed checks ===
  const updatedIndicators = formik.values.MandalIndicators.map((indicator, i) => {
    const newIndicator = { ...indicator };
    const unitCatId = indicator.unit_cat_id;

    // Normalize values
    mandals.forEach((mandal) => {
      const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
        ? mandal.ulb_code
        : mandal.mandal_code;
      const rawValue = indicator[`entry_${code}`];
      newIndicator[`entry_${code}`] =
        rawValue === 0 || rawValue === "0"
          ? "0"
          : rawValue === "" || rawValue == null
          ? ""
          : rawValue.toString();
    });

    // Collect values
    const allMandalValues = mandals.map((mandal) => {
      const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
        ? mandal.ulb_code
        : mandal.mandal_code;
      const rawVal = newIndicator[`entry_${code}`];
      if (unitCatId === 1) {
        const plainVal = convertFormattedToPlainNumber(rawVal);
        if (isNaN(plainVal) || plainVal === "") return null;
        return parseFloat(Number(plainVal).toFixed(3));
      } else {
        const val = parseFloat(rawVal);
        return isNaN(val) ? null : val;
      }
    });

    // Calculate totals
    let total = "";
    if (unitCatId === 1) {
      total = allMandalValues.reduce((sum, val) => sum + (val ?? 0), 0);
      total = parseFloat(total).toFixed(3);
    } else {
      total = "-";
    }
    newIndicator.total = total;

    // District target exceed check
    const rawDistTarget = indicatorsList[i]?.district_target_2025;
    const distTarget =
      rawDistTarget === null || rawDistTarget === "" ? 0 : convertFormattedToPlainNumber(rawDistTarget);
    const totalVal = parseFloat(convertFormattedToPlainNumber(total || "0"));

    if (unitCatId === 1) {
      if (!isNaN(distTarget) && !isNaN(totalVal) && (distTarget === 0 ? totalVal > 0 : totalVal > distTarget)) {
        let changedCode = "";
        for (let j = 0; j < mandals.length; j++) {
          const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
            ? mandals[j].ulb_code
            : mandals[j].mandal_code;
          const prevVal = prevIndicatorsRef.current[i]?.[`entry_${code}`];
          const currentVal = newIndicator[`entry_${code}`];
          if (prevVal !== currentVal) {
            changedCode = code;
            break;
          }
        }

        if (changedCode) {
          showAlertMessage(
            `Total for Indicator "${indicatorsList[i]?.indicator_name}" exceeds District Target (${distTarget}).`,
            "warning",
            () => {
              formik.setFieldValue(`MandalIndicators[${i}].entry_${changedCode}`, "");

              const correctedValues = mandals.map((mandal) => {
                const code = ulbdeptlist.includes(roleid === "8" ? formik.values.department_id : deptId)
                  ? mandal.ulb_code
                  : mandal.mandal_code;
                if (code === changedCode) return null;
                const rawVal = newIndicator[`entry_${code}`];
                if (unitCatId === 1) {
                  const plainVal = convertFormattedToPlainNumber(rawVal);
                  if (isNaN(plainVal) || plainVal === "") return null;
                  return parseFloat(Number(plainVal).toFixed(3));
                } else {
                  const val = parseFloat(rawVal);
                  return isNaN(val) ? null : val;
                }
              });

              let correctedTotal = "";
              if (unitCatId === 1) {
                correctedTotal = correctedValues.reduce((sum, val) => sum + (val ?? 0), 0);
                correctedTotal = parseFloat(correctedTotal).toFixed(3);
                formik.setFieldValue(`MandalIndicators[${i}].total`, formatNumberIndianWithDecimal(correctedTotal));
              }
            }
          );
        }
      }
    }

    return newIndicator;
  });

  // Update Formik if totals changed
  let hasChanged = false;
  for (let i = 0; i < updatedIndicators.length; i++) {
    if (formik.values.MandalIndicators[i]?.total !== updatedIndicators[i]?.total) {
      hasChanged = true;
      break;
    }
  }
  if (hasChanged) {
    formik.setFieldValue("MandalIndicators", updatedIndicators);
  }

  // Save current state for next diff check
  prevIndicatorsRef.current = JSON.parse(JSON.stringify(updatedIndicators));
}, [formik.values.MandalIndicators, mandals, indicatorsList]);







useEffect(() => {
  if (!formik.values?.DistIndicators || !districts?.length || !indicatorsList?.length) return;

  const updatedIndicators = formik.values.DistIndicators.map((indicator) => {
    const newIndicator = { ...indicator };

    
    districts.forEach(({ district_id }) => {
      const rawValue = indicator[`entry_${district_id}`];
      newIndicator[`entry_${district_id}`] = rawValue;
    });

   
    const unitCatId = indicator.unit_cat_id;
    const allDistrictValues = districts.map(({ district_id }) => {
      const rawVal = newIndicator[`entry_${district_id}`];
      const parsedVal = parseFloat(rawVal);
    
      return (rawVal === null || rawVal === undefined || rawVal === "" || isNaN(parsedVal))
        ? 0
        : parsedVal;
    });

    let total = "";
     

    if (unitCatId === 1) {

      total = allDistrictValues.reduce((sum, val) => sum + val, 0);
      
    } else if ([2, 3, 4, 9, 10, 11, 12].includes(unitCatId)) {
      total = allDistrictValues.reduce((sum, val) => sum + val, 0) / (districts.length || 1);
      total = parseFloat(total)?.toFixed(3);
    
    }

    newIndicator.total = total;

    return newIndicator;
  });

  const isChanged = updatedIndicators.some((updated, i) =>
    updated.total !== formik.values.DistIndicators[i]?.total
  );

  if (isChanged) {
    formik.setFieldValue("DistIndicators", updatedIndicators, false);
  }

}, [formik.values.DistIndicators, districts, indicatorsList]);



const matchedMandal = mandals?.find(mandal => {
  const mandal_name = ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId) ? mandal.ulb_name : mandal.mandal_name;
  return mandal_name?.toLowerCase().includes(searchText.toLowerCase());
});
const matchedIndicators = indicatorsList.filter(({ indicator_name }) =>
  indicator_name.toLowerCase().includes(searchText.toLowerCase())
);

const { filteredMandals, filteredIndicators } = useMemo(() => {
  if (!searchText) {
    return {
      filteredMandals: mandals,
      filteredIndicators: indicatorsList,
    };
  }

  if (matchedMandal) {
    return {
      filteredMandals: [matchedMandal], 
      filteredIndicators: indicatorsList,
    };
  }

  if (matchedIndicators.length > 0) {
    return {
      filteredMandals: mandals, 
      filteredIndicators: matchedIndicators, 
    };
  }

  return {
    filteredMandals: [],
    filteredIndicators: [],
  };
}, [searchText, indicatorsList, mandals]);

const matchedDistrict = districts.find(({ district_name }) =>
  district_name.toLowerCase().includes(searchText.toLowerCase())
);

const matchedDistIndicators = indicatorsList.filter(({ indicator_name }) =>
  indicator_name.toLowerCase().includes(searchText.toLowerCase())
);

const { filteredDistricts, filteredDistIndicators } = useMemo(() => {
  if (!searchText) {
    return {
      filteredDistricts: districts,
      filteredDistIndicators: indicatorsList,
    };
  }

  if (matchedDistrict) {
    return {
      filteredDistricts: [matchedDistrict], 
      filteredDistIndicators: indicatorsList,
    };
  }

  if (matchedDistIndicators.length > 0) {
    return {
      filteredDistricts: districts, 
      filteredDistIndicators: matchedDistIndicators, 
    };
  }

  return {
    filteredDistricts: [],
    filteredDistIndicators: [],
  };
  
}, [searchText, indicatorsList, districts]);




const HodentryEnb = (type, val,yearr) => {
  if(!yearr){ showAlertMessage("Please Select Year", "warning"); return;}
  formik.setFieldValue("Indicators", []);
  formik.setFieldValue("DistIndicators", []);

  setIndicatorsList([]); setDistricts([]); setdisablee(false); setbuttonenb(true); setseqid(""); setupdateenb(false); setEntryEnb(false); setEnbSub(false);

  setActiveTab(type)
        const paramss = {
          type: "get",
          userId: username,
          deptId: roleid === "8" ? val : deptId,
          ...(["60", "5", "8"].includes(roleid) ? { buttonType: type } : {}),
          districtId: "0",
          mandalId: "0",
          "year":yearr,
       
        };


if (type === "District") { setEntryEnb(true); setEnbSub(false); fetchdistdata(paramss); }

if (type === "HOD") { setEntryEnb(false); setEnbSub(true); fetchdata(paramss); }   
};




 const SaveEntryData =   (type) => {
  if(!formik.values.year){ 
    showAlertMessage("Please Select Year", "warning"); return;}
    let missingFields = [];
    
    if(type==="0"){
    if (!district) missingFields.push("District");
    }
   if(type === "District"){
    if (!formik.values.district_id) missingFields.push("District");
   }
   if(roleid === "8"){
    if (!formik.values.department_id) missingFields.push("HOD");}
    
  
      if(missingFields.length > 0){
    const errorMessage = `Please Select Required Field ${missingFields.join(",")}.`;
    showAlertMessage(errorMessage, "warning");
    return;
    }
  const val =validatevalue();

  if(!val){ showAlertMessage("At least one entry value must be provided.","warning"); return; }
  store.dispatch({ type: "SHOW_SPINNER" });

    let params = {
      type: "save", userId: username, deptId:  roleid === "8" ? formik.values.department_id:deptId, 
      ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType: type} : {},
      entryType:"hod_level",
      "districtId":type==="HOD" ?  "HD00" : (roleid === "2" || roleid === "32") ? district : formik.values.district_id , 
      mandalId:(roleid === "60" || roleid === "5" || roleid === "8")? "0" :formik.values.mandal_id,year: formik.values.year,indicaterEntryDto:[],
   sequenceId:seqid
    };
    params.indicaterEntryDto = formik.values.Indicators?.map((item, index) => (item.entry_value && !(item.status_id === 4)) ? { indicator_id: item.indicator_id, unit: item.unit, 
      targets_2025: item.unit_cat_id == 13 ? item.entry_value: convertFormattedToPlainNumber(item.entry_value), statusId:item.status_id  } : null ).filter(Boolean);
    
      KpiService.SaveTargetEntrylist(params)
      .then((res) => {
        setupdateenb(true);
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            let params2={ "type": "get", "userId": username, ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:type} : {} , "deptId": roleid === "8" ? formik.values.department_id:deptId,
             "districtId":type==="HOD" ?  "0" : (roleid === "2" || roleid === "32") ? district : formik.values.district_id , "mandalId": (roleid === "60" || roleid === "5"|| roleid === "8") ? "0":formik.values.mandal_id, 
              "year":formik.values.year, }
            fetchdata(params2);
          })
  
        } 
        else {
          showAlertMessage(res.data.SDESC, "warning",()=>{
            setdisablee(false); setbuttonenb(true);
          });
        
        }
      })
      .catch((err) => { showAlertMessage("Failed to save data. Please try again.", "warning"); })
      .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };


  const SaveMandalEntryData =   (type) => {
    if(!formik.values.year){ showAlertMessage("Please Select Year", "warning"); return;}
    let missingFields = [];
    
    if(type==="0"){
    if (!district) missingFields.push("District");
    }
 
  

    let params = {
      type: "save", userId: username, deptId:  roleid === "8" ? formik.values.department_id:deptId, 
      buttonType: type,
      entryType:"cpo_level",
      "districtId": district , 
      // "mandalId": "MD",
      "mandalId": ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?"UT":"MD",
      sequenceId:seqid,
       year:formik.values.year,indicaterEntryDto:[]
  
    };
    let hasValidValue = false;
    const indicators = formik.values.MandalIndicators || [];
    params.indicaterEntryDto = indicators.flatMap((indicator) => {
  return mandals.map((mandal) => {
const code = ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId) ? mandal.ulb_code : mandal.mandal_code;
    const key = `entry_${code}`; const cat_id = `entry_${code}.unit_cat_id`; const unit_cat_id =indicator[cat_id]; const value = indicator[key];const statusid = indicator.status_id;
    const ind_type = indicator.ind_type;
    if (value !== "" && value != null&& !(statusid === 4)) {
      hasValidValue = true; 
      return { district_id: district , mandal_id: ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?"0":mandal.mandal_code, ulb_id:ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?mandal.ulb_code:"0", indicator_id: indicator.indicator_id, unit: indicator.unit, targets_2025:unit_cat_id == 13 ? value:convertFormattedToPlainNumber(value),statusId:indicator.status_id };
    }
    return null;
  }).filter(Boolean);
});


if (!hasValidValue) { showAlertMessage("Please enter at least one value before Save.","warning"); return; }

store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.SaveTargetEntrylist(params).then((res) => {
        setupdateenb(true);
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            let params2={ "type": "get",  buttonType: "CPO","userId": username, ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:type} : {} , "deptId": roleid === "8" ? formik.values.department_id:deptId,
             "districtId":roleid === "8" ? formik.values.district_id:district, "mandalId": "0", "year": formik.values.year }
            fetchmandaldata(params2);
          })
           
        } 
        else {
          showAlertMessage(res.data.SDESC, "warning",()=>{
            setdisablee(false); setbuttonenb(true);
            // formik.values.Indicators.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })
          });
        
        }
      })
      .catch((err) => { showAlertMessage("Failed to save data. Please try again.", "warning"); })
      .finally(() => { setSearch("");store.dispatch({ type: "HIDE_SPINNER" }); });
  };
 const SaveDistEntryData =   (type) => {
if(!formik.values.year){ showAlertMessage("Please Select Year", "warning"); return;}
  
    let missingFields=[];
   
   
   if(roleid === "8"){
    if (!formik.values.department_id) missingFields.push("HOD");}
    
  
      if(missingFields.length > 0){
    const errorMessage = `Please Select Required Field ${missingFields.join(",")}.`;
    showAlertMessage(errorMessage, "warning");
    return;
    }

 

  let params = {
  type: "save",
  userId: username,
  deptId: roleid === "8" ? formik.values.department_id : deptId,
  ...(roleid === "60" || roleid === "5" || (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? { buttonType: type } : {},
  entryType: "District_level",
 districtId:"00DT",
 mandalId:"0",
 sequenceId:seqid,
  year:formik.values.year,
  indicaterEntryDto: [],
};
const indicators = formik.values.DistIndicators || [];

let hasValidValue = false; 
params.indicaterEntryDto = indicators.flatMap((indicator) => {
  return districts.map((district) => {
    const key = `entry_${district.district_id}`;
    const cat_id = `entry_${district.district_id}.unit_cat_id`;
    const statusid = indicator.status_id;
    const ind_type = indicator.ind_type;
    const value = indicator[key];
    const unit_cat_id =indicator[cat_id]
    if (value !== "" && value != null && !(statusid === 4)) {

      hasValidValue = true; 
      
      return { district_id: district.district_id, indicator_id: indicator.indicator_id, unit: indicator.unit, targets_2025:unit_cat_id == 13 ? value:convertFormattedToPlainNumber(value), statusId:statusid};
    }

    return null;
  }).filter(Boolean);
});
console.log("params",params);
if (!hasValidValue) {
  showAlertMessage("Please enter at least one value before Save.","warning");
  return;
}
store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.SaveTargetEntrylist(params).then((res) => {
        setupdateenb(true);
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            let params2={ "type": "get", "userId": username, ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:type} : {} , "deptId": roleid === "8" ? formik.values.department_id:deptId,
             "districtId":"0" , "mandalId": "0","year":formik.values.year }
           fetchdistdata(params2);
          })
           

        } 
        else {
          showAlertMessage(res.data.SDESC, "warning",()=>{
            setdisablee(false); setbuttonenb(true);
          });
        
        }
      }).catch((err) => { showAlertMessage("Failed to save data. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
 
  };
  const hoddata=(val,year)=>{
  setEntryEnb(false);
  setEnbSub(false);
  HodentryEnb('HOD',val,year);

  }
  const validatevalue=()=>{
    let val =false;
    formik.values.Indicators.map((item, index) => {
      if(item.entry_value){
        val= true;
      }
    })
    return val;
   
  }

  const updateData = (type) => {
    setButtontype(type);
    const val =validatevalue();
    if(!val){
      showAlertMessage("At least one entry value must be provided.","warning");
      return;
    }
    setshowModal(true);
   
  };

   const distupdateData = (type) => {
    setButtontype(type);
    if(!isbuttonChecked){
        showAlertMessage("Please Select Checkbox...","warning");
      return;}
    // const val =validatevalue();
    // if(!val){
    //   showAlertMessage("At least one entry value must be provided.","warning");
    //   return;
    // }
    setshowModal(true);
   
  };
 
  const handleKeyDown = (e) => {
  if (e.key === 'Enter' || e.key === 'Escape') {
    e.preventDefault();
    e.stopPropagation();
  }
};

const [isbuttonChecked, setIsbuttonChecked] = useState(false);
 const handleCheckforward = (e) => {
    setIsbuttonChecked(e.target.checked);
  };
const multidistupdate=()=>{
  if(!formik.values.year){ 
    showAlertMessage("Please Select Year", "warning"); return;}
let params = { type: "update", userId: username, entryType:"District_level",
  deptId:  roleid === "8" ? formik.values.department_id:deptId, 
  districtId:"00DT", ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:buttontype} : {} , 
  mandalId:"0", sequenceId:seqid,year:formik.values.year, indicaterEntryDto:[] };

const indicators = formik.values.DistIndicators || [];
let hasValidValue = false;
params.indicaterEntryDto = indicators.flatMap((indicator) => {
  return districts.map((district) => {
    const key = `entry_${district.district_id}`;
    const cat_id = `entry_${district.district_id}.unit_cat_id`;
    const unit_cat_id =indicator[cat_id];
    const value = indicator[key];
   const ind_type = indicator.ind_type;
   const statusid = indicator.status_id;
    if (value !== "" && value != null && !(statusid === 4)) {

      hasValidValue = true; 
      return { district_id: district.district_id, indicator_id: indicator.indicator_id, unit: indicator.unit, targets_2025:unit_cat_id == 13 ? value:convertFormattedToPlainNumber(value), };
    }
    return null;
  }).filter(Boolean);
});
if (!hasValidValue) {
  setshowModal(false);
  showAlertMessage("Please enter at least one value before Save.","warning");
  return;
}

 setshowModal(false); 
store.dispatch({ type: "SHOW_SPINNER" });
KpiService.SaveTargetEntrylist(params)
  .then((res) => {
   setupdateenb(true);
    if (res.data.SCODE === "01") {
      showAlertMessage(res.data.SDESC, "success", () => {
  let params2={ "type": "get", "userId": username, ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:"District"} : {} , "deptId": roleid === "8" ? formik.values.department_id:deptId,
             "districtId":"0" , "mandalId": "0","year":formik.values.year }
           fetchdistdata(params2);
})
    } else {
      showAlertMessage(res.data.SDESC, "warning",()=>{
        setdisablee(false); setbuttonenb(true);   
        // formik.values.DistIndicators.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })
      });
    }
  })
  .catch((err) => {
    setshowModal(false);
    showAlertMessage("Failed to save data. Please try again.", "warning");
  })
  .finally(() => {
setIsbuttonChecked(false);
    store.dispatch({ type: "HIDE_SPINNER" });
  });
}

const multimandalupdate=()=>{
  
if(!formik.values.year)
  { showAlertMessage("Please Select Year", "warning"); 
    return;}

let params = { type: "update", userId: username, entryType:"cpo_level",
  deptId:  roleid === "8" ? formik.values.department_id:deptId, 
  districtId:district,
   buttonType:buttontype, sequenceId:seqid,
  // mandalId:"MD",
  "mandalId": ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?"UT":"MD",
   year:formik.values.year,indicaterEntryDto:[] };


  let hasValidValue = false; const indicators = formik.values.MandalIndicators || [];
    params.indicaterEntryDto = indicators.flatMap((indicator) => {
  return mandals.map((mandal) => {
  const code = ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId) ? mandal.ulb_code : mandal.mandal_code;
    const key = `entry_${code}`; const cat_id = `entry_${code}.unit_cat_id`; const unit_cat_id =indicator[cat_id];
const statusid = indicator.status_id;
    const ind_type = indicator.ind_type;
    const value = indicator[key];
   
    if (value !== "" && value != null&& !(statusid === 4)) {
    
      hasValidValue = true; 
      return { district_id: district , mandal_id: ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?"0":mandal.mandal_code, ulb_id:ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?mandal.ulb_code:"0", indicator_id: indicator.indicator_id, unit: indicator.unit, targets_2025:unit_cat_id == 13 ? value:convertFormattedToPlainNumber(value), };
    }
    return null;
  }).filter(Boolean);
});
if (!hasValidValue) { setshowModal(false); showAlertMessage("Please enter at least one value before Save.","warning"); return; }
setshowModal(false);
store.dispatch({ type: "SHOW_SPINNER" });
KpiService.SaveTargetEntrylist(params).then((res) => {
     setupdateenb(true);
    if (res.data.SCODE === "01") {
      showAlertMessage(res.data.SDESC, "success", () => {
  let params2={ "type": "get",  buttonType: "CPO","userId": username, ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:"District"} : {} , "deptId": roleid === "8" ? formik.values.department_id:deptId,
             "districtId":roleid === "8" ? formik.values.district_id:district , "mandalId": "0", "year": formik.values.year,  }
           fetchmandaldata(params2);
})
    } else {
      showAlertMessage(res.data.SDESC, "warning",()=>{
        setdisablee(false); setbuttonenb(true);   
        // formik.values.DistIndicators.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })
      });
    }
  })
  .catch((err) => {
    setshowModal(false);
    showAlertMessage("Failed to save data. Please try again.", "warning");
  })
  .finally(() => {
    setSearch("");
setIsbuttonChecked(false);
    store.dispatch({ type: "HIDE_SPINNER" });
  });
}
const handleConfirm =()=>{
if(!formik.values.year)
  { showAlertMessage("Please Select Year", "warning"); return;}
let params = { type: "update", userId: username, entryType:"hod_level",
  deptId:  roleid === "8" ? formik.values.department_id:deptId, 
  districtId:buttontype==="HOD" ?  "HD00" : (roleid === "2" || roleid === "32") ? district : formik.values.district_id , ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:buttontype} : {} , 
  mandalId:(roleid === "60" || roleid === "5"|| roleid === "8") ? "0" : formik.values.mandal_id, sequenceId:seqid, year: formik.values.year,indicaterEntryDto:[],
  };



let allFieldsFilled = true;

// params.indicaterEntryDto = formik.values.Indicators?.map((item) => {
//   const value = item.entry_value;

//   if (value === "" || value == null) {
//     allFieldsFilled = false; 
//   }
// if (item.ind_type === "O" && item.status_id === 4) {
//         return null;
//       }
//   return {
//     indicator_id: item.indicator_id,
//     unit: item.unit,
//     targets_2025: item.unit_cat_id == 13 ? value:  convertFormattedToPlainNumber(value)
//   };

// });


params.indicaterEntryDto = formik.values.Indicators
  ?.map((item) => {
    const value = item.entry_value;

    
    if (value === "" || value == null) {
      allFieldsFilled = false;
      return null;
    }

    
    if (item.status_id === 4) {
      return null;
    }

    
    return {
      indicator_id: item.indicator_id,
      unit: item.unit,
      targets_2025:
        item.unit_cat_id == 13
          ? value
          : convertFormattedToPlainNumber(value),
    };
  })
  .filter((entry) => entry !== null);

if (!allFieldsFilled) {
  setshowModal(false);
  showAlertMessage("Please Enter All Indicator's Target values before Submit & Freeze", "warning");
  return;
}

store.dispatch({ type: "SHOW_SPINNER" });
KpiService.SaveTargetEntrylist(params)
  .then((res) => {
    setshowModal(false); setupdateenb(true);
    if (res.data.SCODE === "01") {
      showAlertMessage(res.data.SDESC, "success", () => {
 let params1={ "type": "get", "userId": username, "deptId": roleid === "8" ? formik.values.department_id:deptId, 
  "districtId":buttontype==="HOD" ?  "0" : (roleid === "2" || roleid === "32") ? district : formik.values.district_id
  , ...(roleid === "60" || roleid === "5"|| (roleid === "8" && menuEntry === "HOD & District Targets Entry")) ? {buttonType:buttontype} : {} ,"mandalId": (roleid === "60"|| roleid === "5")? "0":formik.values.mandal_id , "year":formik.values.year,}

fetchdata(params1) ;
    })
    } else {
      showAlertMessage(res.data.SDESC, "warning",()=>{
        setdisablee(false); setbuttonenb(true);   
        // formik.values.Indicators.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })
      });
    }
  })
  .catch((err) => {
    showAlertMessage("Failed to save data. Please try again.", "warning");
  })
  .finally(() => {
    store.dispatch({ type: "HIDE_SPINNER" });
  });
}
const handleClose=()=>{
setshowModal(false);
}

const TableData=(val,yearr)=>{
  setEntryEnb(false);
   if(!yearr){ showAlertMessage("Please Select Year", "warning"); return;}

  if(!val){return;}
  
let paramss={ "type": "get", buttonType: "CPO","userId": username ,"deptId": roleid === "8" ? formik.values.department_id:deptId, "districtId":val, "mandalId":"0", "year": yearr,  }
fetchmandaldata(paramss);
}


// const fetchmandaldata = (paramss) => {
// setIsbuttonChecked(false);
//   setstatuscheck(null);
//   setEntryEnb(true);
//   setEnbSub(false);
// setseqid(null);
// setstatusId(null);

//   let params = {
//     deptId: roleid === "8" ? formik.values.department_id:deptId,
//     userId: username,
//     ...(roleid === "60" || roleid === "5" || (roleid === "8"&& menuEntry === "HOD & District Targets Entry")) ? { buttonType: "HOD" } : {}
//   };
//   store.dispatch({ type: "SHOW_SPINNER" });
//         KpiService.SaveTargetEntrylist(paramss).then((res) => {
//             if (res.data.SCODE === "01") {
//               const dataList = res.data.dataList;
//               const mandalDataList = res.data?.mandalDataList;
//               const mandalMap = {};
//               const uniqueMandals = [];
//               const statusTracker = {};
//               setMaxlen(res.data.dataList[0].max_length)
// if(!mandalDataList || mandalDataList.length == 0){setContainer(true);setalertenb(true)}
// else{setContainer(false);setalertenb(false)}
// if (ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)) {
//    dataList.forEach(({ ulb_code, ulb_name }) => {
//     if (ulb_code && !mandalMap[ulb_code]) {
//       mandalMap[ulb_code] = ulb_name;
//       uniqueMandals.push({ ulb_code, ulb_name });
//     }
//   });
// } 
// else {
 
//   dataList.forEach(({ mandal_code, mandal_name }) => {
//     if (mandal_code && !mandalMap[mandal_code]) {
//       mandalMap[mandal_code] = mandal_name;
//       uniqueMandals.push({ mandal_code, mandal_name });
//     }
//   });
// }
// setmandals(uniqueMandals);

//               const indicatorMap = {};
//               const indicatorsList = [];

//               dataList.forEach(item => {
//                 const {
//                   indicator_id,
//                   indicator_name,
//                   unit,
//                   unit_id,
//                   targets_2025,
//                   mandal_code,
//                   ulb_code,
//                   district_target_2025,
//                   unit_cat_id,status_id,
//           ind_type
//                 } = item;

//                 if (!indicator_id) return;

//                 if (!statusTracker[indicator_id]) {
//           statusTracker[indicator_id] = new Set();
//         }
//         if (status_id !== null && status_id !== undefined) {
//           statusTracker[indicator_id].add(status_id);
//         }
//                 if (!indicatorMap[indicator_id]) {
//                   indicatorMap[indicator_id] = {
//                     indicator_id: parseInt(indicator_id),
//                     indicator_name,
//                     unit_name: unit,
//                     unit: unit_id,
//                     district_target_2025: district_target_2025 ?? "",
//                     unit_cat_id:unit_cat_id,
//                     status_id:null,
//           ind_type:ind_type
//                   };
//                   indicatorsList.push(indicatorMap[indicator_id]);
//                 }

//                 indicatorMap[indicator_id][`entry_${ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?ulb_code: mandal_code}`] = targets_2025 ?? "";
               

//               });


//                 Object.keys(statusTracker).forEach(indId => {
//         const statuses = Array.from(statusTracker[indId]);
//         if (statuses.length === 1) { indicatorMap[indId].status_id = statuses[0]; } else { indicatorMap[indId].status_id = null; }
//       });
// const indicatorsWithAllMandals = indicatorsList.map(ind => {
//   if (ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)) {
//     uniqueMandals.forEach(({ ulb_code }) => {
//       const key = `entry_${ulb_code}`;
//       if (!(key in ind)) ind[key] = "";
//     });
   
//   } else {
//      uniqueMandals.forEach(({ mandal_code }) => {
//       const key = `entry_${mandal_code}`;
//       if (!(key in ind)) ind[key] = "";
//     });
//   }
//   return ind;
// });

// if (Array.isArray(mandalDataList)) {
//   mandalDataList.forEach(({ indicator_id, district_target_count }) => {
//     const targetIndicator = indicatorsWithAllMandals.find(ind => ind.indicator_id === parseInt(indicator_id));
//     if (targetIndicator) {
//       targetIndicator.district_target_2025 = district_target_count;
//     }
//   });
// }

        

//               setIndicatorsList(indicatorsWithAllMandals);
//               formik.setFieldValue("MandalIndicators", indicatorsWithAllMandals);

             
  
//       let hasStatus4 = false; let hasNWith4 = false; let hasNew = false; let selectedSeq = null; let selectedYear = null; let selectedstatus = null;

//       dataList.forEach((item) => {
//         if (item.status_id !== null) { selectedSeq = item.sequence_id; selectedYear = item.year; selectedstatus = item.status_id; }
//         if (item.status_id === 4) { hasStatus4 = true; setstatuscheck(item.status_id); }
//         if (item.ind_type === "N") { hasNew = true; }
//       });

//       indicatorsWithAllMandals.forEach((item) => { if (item.ind_type === "N" && item.status_id !== 4) { hasNWith4 = true; } });

//       if ((hasStatus4 && !hasNWith4) || (hasStatus4 && !hasNew)) { setseqid(selectedSeq); setstatusId(4); setyear(selectedYear); } 
//       else if (hasStatus4 && hasNWith4) { setseqid(selectedSeq); setstatusId(null); setyear(selectedYear); } 
//       else { setseqid(selectedSeq); setstatusId(selectedstatus); setyear(selectedYear); }
//             }
//             else{ if(roleid === "2"|| roleid === "8"){ setContainer(true);setalertenb(false) } }
//           })
//           .catch(() => { showAlertMessage("Failed to fetch data.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    
// };
const fetchmandaldata = (paramss) => {
   
setIsbuttonChecked(false);
  setstatuscheck(null);
  setEntryEnb(true);
  setEnbSub(false);
setseqid(null);
setstatusId(null);
 setentry_type("");
  let params = {
    deptId: roleid === "8" ? formik.values.department_id:deptId,
    userId: username,
    ...(roleid === "60" || roleid === "5" || (roleid === "8"&& menuEntry === "HOD & District Targets Entry")) ? { buttonType: "HOD" } : {}
  };
  store.dispatch({ type: "SHOW_SPINNER" });
        KpiService.SaveTargetEntrylist(paramss).then((res) => {
            if (res.data.SCODE === "01") {
              const dataList = res.data.dataList;
              const mandalDataList = res.data?.mandalDataList;
              const mandalMap = {};
              const uniqueMandals = [];
              const statusTracker = {};
              console.log("mandalDataList",res.data.dataList[0].entry_type);
              setentry_type(res.data?.dataList[0]?.entry_type)
              setMaxlen(res.data.dataList[0].max_length)
if(!mandalDataList || mandalDataList.length == 0){setContainer(true);setalertenb(true)}
else{setContainer(false);setalertenb(false)}
if (ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)) {
   dataList.forEach(({ ulb_code, ulb_name }) => {
    if (ulb_code && !mandalMap[ulb_code]) {
      mandalMap[ulb_code] = ulb_name;
      uniqueMandals.push({ ulb_code, ulb_name });
    }
  });
}
else {
 
  dataList.forEach(({ mandal_code, mandal_name }) => {
    if (mandal_code && !mandalMap[mandal_code]) {
      mandalMap[mandal_code] = mandal_name;
      uniqueMandals.push({ mandal_code, mandal_name });
    }
  });
}
setmandals(uniqueMandals);
 
              const indicatorMap = {};
              const indicatorsList = [];
 
              dataList.forEach(item => {
                const {
                  indicator_id,
                  indicator_name,
                  unit,
                  unit_id,
                  targets_2025,
                  mandal_code,
                  ulb_code,
                  district_target_2025,
                  unit_cat_id,status_id,
          ind_type
                } = item;
 
                if (!indicator_id) return;
 
                if (!statusTracker[indicator_id]) {
          statusTracker[indicator_id] = new Set();
        }
        if (status_id !== null && status_id !== undefined) {
          statusTracker[indicator_id].add(status_id);
        }
                if (!indicatorMap[indicator_id]) {
                  indicatorMap[indicator_id] = {
                    indicator_id: parseInt(indicator_id),
                    indicator_name,
                    unit_name: unit,
                    unit: unit_id,
                    district_target_2025: district_target_2025 ?? "",
                    unit_cat_id:unit_cat_id,
                    status_id:null,
          ind_type:ind_type
                  };
                  indicatorsList.push(indicatorMap[indicator_id]);
                }
 
                indicatorMap[indicator_id][`entry_${ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)?ulb_code: mandal_code}`] = targets_2025 ?? "";
               
 
              });
 
 
                Object.keys(statusTracker).forEach(indId => {
        const statuses = Array.from(statusTracker[indId]);
        if (statuses.length === 1) { indicatorMap[indId].status_id = statuses[0]; } else { indicatorMap[indId].status_id = null; }
      });
const indicatorsWithAllMandals = indicatorsList.map(ind => {
  if (ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)) {
    uniqueMandals.forEach(({ ulb_code }) => {
      const key = `entry_${ulb_code}`;
      if (!(key in ind)) ind[key] = "";
    });
   
  } else {
     uniqueMandals.forEach(({ mandal_code }) => {
      const key = `entry_${mandal_code}`;
      if (!(key in ind)) ind[key] = "";
    });
  }
  return ind;
});
 
if (Array.isArray(mandalDataList)) {
  mandalDataList.forEach(({ indicator_id, district_target_count }) => {
    const targetIndicator = indicatorsWithAllMandals.find(ind => ind.indicator_id === parseInt(indicator_id));
    if (targetIndicator) {
      targetIndicator.district_target_2025 = district_target_count;
    }
  });
}
 
       
 
              setIndicatorsList(indicatorsWithAllMandals);
              formik.setFieldValue("MandalIndicators", indicatorsWithAllMandals);
 
             
 
      let hasStatus4 = false; let hasNWith4 = false; let hasNew = false; let selectedSeq = null; let selectedYear = null; let selectedstatus = null;let hasNWithoutTargets = true;
 
      dataList.forEach((item) => {
        if (item.status_id !== null) { selectedSeq = item.sequence_id; selectedYear = item.year; selectedstatus = item.status_id; }
        if (item.status_id === 4) { hasStatus4 = true; setstatuscheck(item.status_id); }
        if (item.ind_type === "N") { hasNew = true; }
      });
 
      indicatorsWithAllMandals.forEach((item) => { if (item.ind_type === "N" && item.status_id !== 4) { hasNWith4 = true;
         
 if (item.district_target_2025 !== null && item.district_target_2025 !== "") {
      hasNWithoutTargets = false;
    }
          
       
      }
    });
 
   
      if ((hasStatus4 && !hasNWith4) || (hasStatus4 && !hasNew)) { setseqid(selectedSeq); setstatusId(4); setyear(selectedYear); }
      else if (hasStatus4 && hasNWith4) {
          if(hasNWithoutTargets) {
            setseqid(selectedSeq);
    setstatusId(4);
    setyear(selectedYear);
                     
  }
  else{ setseqid(selectedSeq); setstatusId(null); setyear(selectedYear); 
       }
       }
      else { setseqid(selectedSeq); setstatusId(selectedstatus); setyear(selectedYear); }
            }
            else{ if(roleid === "2"|| roleid === "8"){ setContainer(true);setalertenb(false) } }
          })
          .catch(() => { showAlertMessage("Failed to fetch data.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
   
};
 
// const fetchdistdata = (paramss) => {

//   formik.values.DistIndicators?.forEach((_, i) => {
//     formik.setFieldValue(`DistIndicators[${i}].totals`, "");
//   });
//   setSearch("");
// setIsbuttonChecked(false);
//   setstatuscheck(null);
//   setEntryEnb(true);
//   setEnbSub(false);
//   setseqid(null);
//   setyear(null);
// setstatusId(null);
// store.dispatch({ type: "SHOW_SPINNER" });
//   KpiService.SaveTargetEntrylist(paramss)
//     .then((res) => {
//       if (res.data.SCODE !== "01") return;

//       const dataList = res.data.dataList;
//       setMaxlen(res.data.dataList[0].max_length)

//       const districtMap = {};
//       const uniqueDistricts = [];

//       dataList.forEach(({ district_id, district_name }) => {
//         if (!districtMap[district_id]) {
//           districtMap[district_id] = true;
//           uniqueDistricts.push({ district_id, district_name });
//         }
//       });

//       setDistricts(uniqueDistricts);

//       const indicatorMap = {};
//       const indicatorsList = [];

//       dataList.forEach(item => {
//         const {
//           indicator_id,
//           indicator_name,
//           unit,
//           unit_id,
//           district_id,
//           targets_2025,
//           district,
//           mandal,
//           unit_cat_id,
//           status_id,
//           ind_type
        
//         } = item;
        
//         if (!indicator_id) return;

//         if (!indicatorMap[indicator_id]) {
//           indicatorMap[indicator_id] = {
//             indicator_id: parseInt(indicator_id),
//             indicator_name,
//             unit_name: unit,
//             unit: unit_id,
//             district,
//             mandal,
//             unit_cat_id:unit_cat_id,
//             status_id:status_id,
//             ind_type:ind_type
//             //  totals: ""
            
//           };
//           indicatorsList.push(indicatorMap[indicator_id]);
//         }

 

//     indicatorMap[indicator_id][`entry_${district_id}`] = targets_2025 ?? "";
 

       
//       });

      
//       const indicatorsWithAllDistricts = indicatorsList.map(ind => {
//         uniqueDistricts.forEach(({ district_id }) => {
//           const keys = [
//             `entry_${district_id}`,
           
//           ];
//           keys.forEach(key => {
//             if (!(key in ind)) ind[key] = "";
//           });
//         });
//         return ind;
//       });

  
  
      
//       setIndicatorsList(indicatorsWithAllDistricts);
//       formik.setFieldValue("DistIndicators", indicatorsWithAllDistricts);
// console.log("indicatorsWithAllDistricts",indicatorsWithAllDistricts);
// //  dataList.forEach((item, i) => {
// //   if (item.status_id !== null) { setseqid(item.sequence_id);
// //     setstatusId(item?.status_id);
// //     setyear(item.year);

// //   }

  
// // })
// // dataList.forEach((item) => {
  
// //   if (item.ind_type === "N" && item.status_id === 4) {
// //     setseqid(item.sequence_id);
// //     setstatusId(item.status_id);
// //     setyear(item.year);
// //   } 
  
// //   else if (item.status_id !== null) {
// //     setseqid(item.sequence_id);
// //     setstatusId(item.status_id);
// //     setyear(item.year);
// //   }
// // });
// let hasStatus4 = false;               // if any indicator has status 4
// let hasNWith4 = false;             // if any N-type indicator has status != 4
// let selectedSeq = null;
// let selectedYear = null;
// let selectedstatus = null;
// let hasNew = false; 
// dataList.forEach((item) => {
//   if(item.status_id!==null){selectedSeq = item.sequence_id;
//     selectedYear = item.year;selectedstatus=item.status_id;setstatuscheck(item.status_id)}
//   if (item.status_id === 4) {
//     hasStatus4 = true; 
   
//   }
//   // if (item.ind_type === "N" && item.status_id !== 4) {
//   //   hasNWith4 = true;  
//   // }
//   if (item.ind_type === "N"){hasNew = true}
// });
// indicatorsWithAllDistricts.forEach((item) => {
//   console.log("item",item);
//   if (item.ind_type === "N" && item.status_id !== 4) {
//     hasNWith4 = true;  
//   }
// });
// if ((hasStatus4 && !hasNWith4) || (hasStatus4 && !hasNew)) {
//   setseqid(selectedSeq);
//   setstatusId(4);
//   setyear(selectedYear);
// } 
// else if (hasStatus4 && hasNWith4) {
//   setseqid(selectedSeq);
//   setstatusId(null);
//   setyear(selectedYear);
// }
// else {
//   setseqid(selectedSeq);
//   setstatusId(selectedstatus);
//   setyear(selectedYear);
// }  

// // else {
  
// //   const anyWithStatus = dataList.find(i => i.status_id !== null);
// //   if (anyWithStatus) {
// //     setseqid(anyWithStatus.sequence_id);
// //     setstatusId(anyWithStatus.status_id);
// //     setyear(anyWithStatus.year);
// //   } else {
// //     setseqid(null);
// //     setstatusId(null);
// //     setyear(null);
// //   }
// // }


   
//     })
//     .catch(() => {
//       showAlertMessage("Failed to fetch data.", "warning");
//     })
//     .finally(() => {
//               store.dispatch({ type: "HIDE_SPINNER" });
//             });
// };




const fetchdistdata = (paramss) => {
  
setContainer(false);
   setentry_type("");

  formik.values.DistIndicators?.forEach((_, i) => { formik.setFieldValue(`DistIndicators[${i}].totals`, ""); });

  setSearch(""); setIsbuttonChecked(false); setstatuscheck(null); setEntryEnb(true); setEnbSub(false); setseqid(null); setyear(null); setstatusId(null);
  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.SaveTargetEntrylist(paramss)
    .then((res) => {
      if (res.data.SCODE !== "01"){ setContainer(true);return;}
      else{
setContainer(false);
setentry_type(res.data?.dataList[0]?.entry_type)
      const dataList = res.data.dataList;
      setMaxlen(dataList[0].max_length);
      const districtMap = {};
      const uniqueDistricts = [];
      dataList.forEach(({ district_id, district_name }) => { if (!districtMap[district_id]) { districtMap[district_id] = true; uniqueDistricts.push({ district_id, district_name }); } });
      setDistricts(uniqueDistricts);
      const indicatorMap = {};
      const indicatorsList = [];
      const statusTracker = {}; 

      dataList.forEach(item => {
        const {
          indicator_id,
          indicator_name,
          unit,
          unit_id,
          district_id,
          targets_2025,
          district,
          mandal,
          unit_cat_id,
          status_id,
          ind_type
        } = item;

        if (!indicator_id) return;

        if (!statusTracker[indicator_id]) {
          statusTracker[indicator_id] = new Set();
        }
        if (status_id !== null && status_id !== undefined) {
          statusTracker[indicator_id].add(status_id);
        }

        if (!indicatorMap[indicator_id]) {
          indicatorMap[indicator_id] = {
            indicator_id: parseInt(indicator_id),
            indicator_name,
            unit_name: unit,
            unit: unit_id,
            district,
            mandal,
            unit_cat_id: unit_cat_id,
            status_id: null,
            ind_type: ind_type
          };
          indicatorsList.push(indicatorMap[indicator_id]);
        }

        indicatorMap[indicator_id][`entry_${district_id}`] = targets_2025 ?? "";
      });

      Object.keys(statusTracker).forEach(indId => {const statuses = Array.from(statusTracker[indId]);
        if (statuses.length === 1) {
          indicatorMap[indId].status_id = statuses[0];
        } else {
          indicatorMap[indId].status_id = null;
        }
      });

   
      const indicatorsWithAllDistricts = indicatorsList.map(ind => {
        uniqueDistricts.forEach(({ district_id }) => {
          const key = `entry_${district_id}`;
          if (!(key in ind)) ind[key] = "";
        });
        return ind;
      });

      setIndicatorsList(indicatorsWithAllDistricts);
      formik.setFieldValue("DistIndicators", indicatorsWithAllDistricts);

      console.log("indicatorsWithAllDistricts", indicatorsWithAllDistricts);

     
      let hasStatus4 = false;      
      let hasNWith4 = false;       
      let hasNew = false;          
      let selectedSeq = null;
      let selectedYear = null;
      let selectedstatus = null;

      dataList.forEach((item) => {
        if (item.status_id !== null) {
          selectedSeq = item.sequence_id;
          selectedYear = item.year;
          selectedstatus = item.status_id;
        }
        if (item.status_id === 4) {
          hasStatus4 = true;
          setstatuscheck(item.status_id);

        }
        if (item.ind_type === "N") {
          hasNew = true;
        }
      });

      indicatorsWithAllDistricts.forEach((item) => {
        if (item.ind_type === "N" && item.status_id !== 4) {
          hasNWith4 = true;
        }
      });

      if ((hasStatus4 && !hasNWith4) || (hasStatus4 && !hasNew)) {
        setseqid(selectedSeq);
        setstatusId(4);
        setyear(selectedYear);
      } 
      else if (hasStatus4 && hasNWith4) {
        setseqid(selectedSeq);
        setstatusId(null);
        setyear(selectedYear);
      } 
      else {
        setseqid(selectedSeq);
        setstatusId(selectedstatus);
        setyear(selectedYear);
      }
      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
};


const[indicatorhodlist,setindicatorhodlist]=useState([]);
const fetchdata=(paramss)=>{
  setContainer(false);
setIsbuttonChecked(false);
  setseqid(null)
  setstatusId(null);
  setyear(null);
   setentry_type("");
if(formik.values.Indicators){
  formik.values?.Indicators?.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })}
  store.dispatch({ type: "SHOW_SPINNER" });

KpiService.SaveTargetEntrylist(paramss)
.then((res) => {
  setEntryEnb(true);
  if (res.data.SCODE === "01") {

     if (res.data.SCODE === "01") {
        const responseList = res.data.dataList || [];
        const isDisabled = responseList[0]?.status_id === 4;
setMaxlen(res.data.dataList[0].max_length)
        setdisablee(isDisabled);
        setbuttonenb(!isDisabled);
setentry_type(res.data?.dataList[0]?.entry_type)
        // Only use responseList to set Indicators
        const uniqueIndicatorsMap = {};

        responseList.forEach(item => {
          const { indicator_id, indicator_name, unit, unit_id, targets_2025,unit_cat_id,status_id,ind_type} = item;
          if (!indicator_id || uniqueIndicatorsMap[indicator_id]) return;

          uniqueIndicatorsMap[indicator_id] = {
            indicator_id: parseInt(indicator_id),
            indicator_name,
            unit_name:unit,
            unit: unit_id,
            unit_cat_id: unit_cat_id,
            entry_value: targets_2025 ?? "",
            status_id: status_id,
           ind_type:ind_type
          };
        });
// responseList.forEach((item, i) => {
 
//   // if (item.status_id !== null) { setseqid(item.sequence_id);setstatusId(item?.status_id);setyear(item.year);
//   // }
//   //  if (item.ind_type === "N" && item.status_id !== 4){ setbuttonenb(true);setstatusId(null) }
//   //  else{setbuttonenb(!isDisabled);}
  
  
//   if (item.ind_type === "N" && item.status_id === 4) { setseqid(item.sequence_id); setstatusId(item.status_id); setyear(item.year);setbuttonenb(false) } 
  
//   else if (item.status_id !== null) { setseqid(item.sequence_id); setstatusId(item.status_id); setyear(item.year); }

// })
let hasStatus4 = false; let hasNWith4 = false; let hasNew = false; let selectedSeq = null; let selectedYear = null; let selectedstatus = null;
let hasNWith0 = false; 
responseList.forEach((item) => {
  
  if(item.status_id!==null){selectedSeq = item.sequence_id; selectedYear = item.year;selectedstatus=item.status_id;setstatuscheck(item.status_id)}
  if (item.status_id === 4) { hasStatus4 = true; }
  if (item.ind_type === "N" && item.status_id === 4) { hasNWith4 = true; }
if (item.ind_type === "N" && item.status_id !== 4) { hasNWith0 = true; }
  if(item.ind_type === "N"){hasNew = true}
});
if (hasNWith0 && hasNew) {setseqid(selectedSeq); setstatusId(selectedstatus); setyear(selectedYear); setbuttonenb(true);}
else if ((hasStatus4 && hasNWith4)|| (hasStatus4 && !hasNew)) { setseqid(selectedSeq); setstatusId(4); setyear(selectedYear); setbuttonenb(false); } 
// else if (hasStatus4 && !hasNWith4) { setseqid(selectedSeq); setstatusId(null); setyear(selectedYear); setbuttonenb(true); }
else { setseqid(selectedSeq); setstatusId(selectedstatus); setyear(selectedYear); setbuttonenb(true); }  

        const indicatorsArray = Object.values(uniqueIndicatorsMap);
setindicatorhodlist(indicatorsArray);
        formik.setFieldValue("Indicators", indicatorsArray);
      } 
  }
  else{
    setContainer(true);
      setdisablee(false); setbuttonenb(true); setseqid(""); setupdateenb(false);
       formik.setFieldValue(`Indicators`,"") 
    
    
  }
}
) .catch(() => {
              showAlertMessage("Failed to fetch data.", "warning");
            })
            .finally(() => {
              store.dispatch({ type: "HIDE_SPINNER" });
            });
}
  return (
    <>
      <Menubar />

      <Container fluid style={{width:"95%"}} className='map-header '>
       
          <div className='sa-title'>
  {(() => {
    if (roleid === "60" || roleid === "5" || (roleid === "8" && menuEntry === "HOD & District Targets Entry")) {
     
      return <h2>Targets <span>Entry</span></h2>;
    }
    if (!["60","5"].includes(roleid)  || (roleid === "8" && menuEntry === "Mandal Targets Entry")) {
      
      return <h2>{ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId) ? "ULB":"Mandal"} Level Targets <span>Entry</span></h2>;
    }
    
  })()}
</div>
      </Container>


      <Container fluid style={{width:"95%"}} className='mt-3 outer-page-content-container'>
        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4'>
              <Row>
             
                                          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> HOD Name</label>
                                           {(roleid === "8"|| roleid === "5") ?(
                                                          <Field component="select" name="department_id" className="mb-3 form-control" onChange={(e)=>{
                                                            // if (menuEntry === "HOD & District Targets Entry") { hoddata(e.target.value); }
                                                             setEntryEnb(false);formik.setFieldValue("department_id",e.target.value);formik.setFieldValue("district_id","");formik.setFieldValue("year","");formik.handleChange(e)}} style={{ fontWeight: "bold" }} disabled={(roleid === "8" ) ? false: true} >
                                                                <option value="">--Select--</option> {Deptlist} </Field> 
                                                                ):(
                         
                                            <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("deptcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}>
                                                              </Field>)}
                                          </Col>
                {((roleid === "32"|| roleid === "2"|| (roleid === "8"&& menuEntry === "Mandal Targets Entry"))) && <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> <Field className="mb-3 form-control" component="select" name="district_id" value={(roleid === "32" || roleid==="2") ? district :(formik.values.district_id? formik.values.district_id : "")}onChange={(e)=>{formik.setFieldValue("year","");setmandals([]);formik.handleChange(e)}}controlId="formBasicEmail"  style={{ fontWeight: "bold" }} disabled ={distEnb}> <option value="">--Select--</option> {distlist} </Field> </Col>}
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold">Financial Year</label>
                                         
                <Field className="form-control" component="select" name="year" controlId="formBasicEmail" onChange={(e) => {
                                                            if ((roleid === "8"&&menuEntry === "HOD & District Targets Entry")|| (!["32","2"].includes(roleid))) { hoddata(formik.values.department_id,e.target.value); }
                   if(((roleid === "32"|| roleid === "2"|| (roleid === "8"&& menuEntry === "Mandal Targets Entry")))){TableData(formik.values.district_id,e.target.value);}
                   formik.handleChange(e) }} style={{ fontWeight: "bold" }} > <option value="">--Select--</option>
                    {Yearlist} 
                    {/* <option value="2026-27">2026-27</option>

                    <option value="2025-26">2025-26</option> */}
                    </Field> 

                                          </Col>
             
              </Row>
            </div>
        

{(roleid === "60" || roleid === "5" || (roleid === "8" && menuEntry === "HOD & District Targets Entry")) &&
            <Tab.Container id="left-tabs-example" activeKey={activeTab} className="mt-5">
             
                <div className="tabs-top mt-5">



                <Nav variant="pills" className="flex-column">
                  <Row className="tabs-row">
    <Col xxl={1} xl={1} lg={3} md={3} sm={12} xs={6} className="px-0">
  <Nav.Item className={`tab-boxes tab-boxes1 ${activeTab === 'HOD' ? 'active-tab' : ''}`} onClick={() => { HodentryEnb('HOD', formik.values.department_id,formik.values.year); setentry_type(""); }} style={{ cursor: 'pointer', }} > <p>HOD</p> </Nav.Item>
</Col>

<Col xxl={1} xl={1} lg={3} md={3} sm={12} xs={6} className="px-0">
  <Nav.Item className={`tab-boxes tab-boxes2 ${activeTab === 'District' ? 'active-tab' : ''}`} onClick={() => { HodentryEnb('District', formik.values.department_id,formik.values.year);setentry_type(""); }} style={{ cursor: 'pointer', }} > <p>District</p> </Nav.Item>
</Col>


                    <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4">
                    </Col>
                    <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4">
                    </Col>
                  
                  </Row>
                </Nav>


              </div>
           
                  <Row className="justify-content-center">
                    <Col xs={12} sm={12} lg={12} md={12} xl={12} xxl={12}>
                     




                    
                    </Col>
                  </Row>

              <Row>



                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">

                  
                  <Tab.Content className="tabs-body-text">

                  {enbSub&&
                      <Tab.Pane eventKey="HOD">
                        
                     {!container && 
              <Row>
                <Col xxl={9} xl={9} lg={12} md={12} sm={12} xs={12} className="">

                        <Button variant="danger" size="sm" className="btn mx-2 mt-2 mb-1 pdf-btn" onClick={()=>generateentryPdf("my-table",formik.values,"TargetEntry")} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /></Button>
                        <Button variant="success" size="sm" className="btn mx-2 mt-2 mb-1 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToentryExcel("my-table", formik.values,"TargetEntry")} > <span style={{ color: "green" }}> Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </span> </Button>
                        <div id="table-scroll" className="mt-5" style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }} >
                        <table className="table table-bordered custom-table table-responsive w-100" id="my-table">
                        <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1, }} >
                            <tr className="text-center"> <th rowSpan={2}>Sl.No.</th> <th rowSpan={2}>INDICATOR</th> <th rowSpan={2}>UNIT</th> <th colSpan={1}>TARGETS({formik.values.year})</th> </tr>
                            
                          </thead>
  
            <tbody>
  {indicatorhodlist?.length === 0 ? (
    <tr> <td className="text-center" colSpan="4"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
  ) : (
    indicatorhodlist?.map((detail, i) => (
      <tr key={i}>
        <td style={{ textAlign: "center" }}>{i + 1}</td> <td style={{ textAlign: "left" }}>
           {(detail.ind_type === "N" && buttonenb && detail.status_id!== 4) &&
                                      <img src="../images/new3.gif" width="20px" alt="new" style={{ marginRight: "5px" }} />
                                      }{detail.indicator_name}
          </td> <td style={{ textAlign: "left" }}>{detail.unit_name}</td>

        <td className="text-end">
        {detail.unit_cat_id !== 13 ? (
          <Field
            autoComplete="off"
            name={`Indicators[${i}].entry_value`}
            className="form-control"
            type="text"
            style={{ textAlign: "right" }}
            disabled={formik.values.Indicators[i]?.status_id === 4}
            value={detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal(formik.values.Indicators[i]?.entry_value || "") : formik.values.Indicators[i]?.entry_value || ""}
           
            onBlur={(e) => { handleInputChange(e, i,"entry_value","HOD"); formik.handleChange(e); }}
            onInput={(e) => {
               if(detail.unit_cat_id === 1){
                allowNumberswithMaxLengthcatidtypeOnly(e, maxLen, "numeric", 3);
              }
              else{
allowNumberswithMaxLengthtypeOnly(e, maxLen, "numeric", 3)
              }
            }
            }
              {...detail.unit_cat_id === 1 ? 
                restrictToPasteOnlyEightDotcommaThreeAllowKeyPress( formik,"HOD","entry_value", i )
            :restrictToPasteOnlyEightDotThreeAllowKeyPress( formik,"HOD","entry_value", i)}
          />  ) : (
            <Field component="select" name={`Indicators[${i}].entry_value`} className="form-control mb-3" style={{ fontWeight: "bold" }} disabled={disablee} >
              <option value="">--Select--</option>
              <option value="100">TOP ACHIEVERS</option>
              <option value="75">ACHIEVERS</option>
              <option value="50">FAST MOVERS</option>
              <option value="25">ASPIRERS</option>
            </Field>
          )}
        </td>
      </tr>
    )) //
  )}
</tbody>


                        </table>
                        </div>
                        <div className="bottom-buttons d-flex justify-content-center mt-4 mb-5">
                     {buttonenb && <> <Button variant="" size="sm" className="save-btn me-4" type="button" onClick={() => SaveEntryData('HOD')} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
                     {roleid != "8" &&
        <Button variant="" size="sm" className="next-btn me-4" type="button" onClick={() =>{ updateData('HOD')}} > Submit&Freeze <FaRegSave className="ms-1 s-icon" /> </Button>
                     }</> 
}
    </div>
                  
</Col>

              </Row>}

              {container && ( <>
         
         
            <Row className="w-100 justify-content-center mt-4 mb-3"> <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={12}> <Alert severity="warning" icon={<FaExclamationTriangle className="blinking-icon" />} sx={{ fontSize: "16px", padding: "40px 32px", borderRadius: "8px", backgroundColor: "#fff3cd", color: "#856404", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", }} >
            HOD Level Indicators Not Available </Alert> </Col> </Row> 
            </> )} 

                      </Tab.Pane>
                     } 

                    {Entryenb&&

                      <Tab.Pane eventKey="District">
                   {!container && 
              <Row>
            
                <Col xxl={12} xl={12} lg={12} md={3} sm={3} xs={3} className="">
                     <div className="alert-card mt-2 mb-1" style={{ padding: "12px 16px", borderRadius: "8px", backgroundColor: "#ecf3f5", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", display: "inline-block" }} >
  <span style={{ color: "#543f3f", fontWeight: "bold", fontSize:"15px" }}>
 
    Note:{" "} 
     
   <span style={{ display: "inline-block", width: "45px", height: "25px", backgroundColor: "white", border: "1px solid #ccc", marginRight: "5px", verticalAlign: "middle" }} ></span>
     Represents District Indicators{" "}
    <span style={{ display: "inline-block", width: "45px", height: "25px", backgroundColor: "rgb(243 231 215)", border: "1px solid #ccc", marginRight: "5px", verticalAlign: "middle" }} ></span> Represents Mandal Indicators </span>
</div>
                                                               
             </Col>
              <Row>
                   <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mt-2 mb-3">
  <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }}
                                                                                                                 onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }}
                                                                                                                 onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }}
                                                                                                               >
                                                                                                                 <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText} onChange={(event) => setSearch(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                                                                                                               </div>
                                                                                                               </Col>
                                                                                                               <Col className="mb-2">
                        <Button variant="success" size="sm" className="btn mx-2 mt-2 mb-1 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToentryExcel("my-table1", formik.values,"TargetEntry")} > <span style={{ color: "green" }}> Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </span> </Button>
                                                                                                             </Col>
                                                                                                             </Row>                                                                                          
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">
                    
                      <div
  id="table-scroll"
  className={`table-scroll  ${statusId == 4 ? 'mb-5' : ''}`}
>

            <div className="table-wrap">
                       
                     
<table className="table table-bordered custom-table table-responsive sticky-table" id="my-table1">
  <thead>
    <tr className="text-center">
      <th rowSpan={2} className="sticky-col sticky-sno">Sl.No.</th>
      <th rowSpan={2} className="sticky-col sticky-INDICATOR indicator-cell">INDICATOR</th>
      <th rowSpan={2} className="sticky-col sticky-UNIT" style={{whiteSpace: "normal", wordWrap: "break-word", maxWidth: "90px",minWidth:"90px" }}>UNIT</th>
      {/* <th  style={{minWidth: "30PX", whiteSpace: "nowrap", wordWrap: "break-word"}} className="sticky-col sticky-totaldist">State</th> */}

      {filteredDistricts.map(d => (
        <th key={`name-${d.district_id}`} className={`${d.district_id=== 55 ? "sticky-col sticky-totaldist":""}`} colSpan={1}>{d.district_name}</th>
      ))}
      {/* <th rowSpan={2} className="sticky-col sticky-total">Total</th> */}
    </tr>
    
    <tr className="text-center">
      {/* <th className="sticky-col sticky-totaldist"  style={{minWidth: "30PX", whiteSpace: "nowrap", wordWrap: "break-word"}}>TARGETS (2025-26)</th> */}
      {filteredDistricts.map(d => (
        <React.Fragment key={`subhead-${d.district_id}`}>
         
          <th className={`${d.district_id=== 55 ? "sticky-col sticky-totaldist":""}`} >TARGETS ({formik.values.year})</th>
        </React.Fragment>
      ))}
    </tr>
  </thead>

  <tbody>
    {filteredDistIndicators.length === 0 ? (
      <tr>
        <td className="text-center" colSpan={3+3  * districts.length}>
          <b style={{ color: "red" }}>Details Not Found</b>
        </td>
      </tr>
    ) : (
      [...filteredDistIndicators]
       
        .map((ind) => {
  const originalIndex = indicatorsList.findIndex((i) => i.indicator_id === ind.indicator_id);
  return {
    ...ind,
    originalIndex,
    isDistrict: formik.values.DistIndicators[originalIndex]?.district === "Yes",
    isMandal: formik.values.DistIndicators[originalIndex]?.mandal === "Yes",
  };
})

        .sort((a, b) => {
          if (a.isDistrict && !b.isDistrict) return -1;
          if (!a.isDistrict && b.isDistrict) return 1;
          if (a.isMandal && !b.isMandal) return -1;
          if (!a.isMandal && b.isMandal) return 1;
          return 0;
        })
        .map((indicator, rowIndex) => {
          const formikIndex = indicator.originalIndex;
          const isMandal = formik.values.DistIndicators[formikIndex]?.mandal === "Yes";

          return (
            <tr key={indicator.indicator_id || `row-${rowIndex}`}>
              <td className="sticky-col sticky-sno text-center" style={{ backgroundColor: isMandal ? "rgb(243 231 215)" : "" }}>
                {rowIndex + 1}
              </td>
              <td className="sticky-col sticky-INDICATOR indicator-column" style={{ backgroundColor: isMandal ? "rgb(243 231 215)" : "" }}>
                {(indicator.ind_type === "N" && statusId !== 4 && indicator.status_id !== 4 ) &&
                                      <img src="../images/new3.gif" width="20px" alt="new" style={{ marginRight: "5px" }} />
                                      } {indicator.indicator_name || ""}
                
                
              </td>
              <td className="sticky-col sticky-UNIT " style={{ whiteSpace: "normal", wordWrap: "break-word", maxWidth: "90px" ,minWidth:"90px",backgroundColor: isMandal ? "rgb(243 231 215)" : "" }}>
                {indicator.unit_name || ""}
              </td>

             
{filteredDistricts.map(({ district_id }) => {
  const entryField = `DistIndicators[${formikIndex}].entry_${district_id}`;
  const fieldValue = indicator.unit_cat_id === 1 ? formatNumberIndianWithDecimal(formik.values.DistIndicators[formikIndex]?.[`entry_${district_id}`]):formik.values.DistIndicators[formikIndex]?.[`entry_${district_id}`];
  // const isDisabled = statusId === 4;
  const rowStatusId = formik.values.DistIndicators[formikIndex]?.status_id;
const indType = formik.values.DistIndicators[formikIndex]?.ind_type;

const isDisabled =
  rowStatusId === 4 || (indType === "O" && statuscheck === 4);
  const isDropdown = indicator.unit_cat_id === 13; 
 if(formik.values.DistIndicators[formikIndex]?.ind_type === "N"){console.log("formik.values.DistIndicators[formikIndex]?.ind_type",isDisabled)}
  return (
    <React.Fragment key={`cell-${district_id}`}>
      <td
        className= {`${district_id=== 55 ? "sticky-col sticky-totaldist":""} text-end`}
        style={{  zIndex: district_id=== 55 && 2, backgroundColor: isMandal ? "rgb(243 231 215)" : "" }}
      >
        {isDropdown ? (
          <Field component="select" name={entryField} className="form-control mb-3" disabled={isDisabled} style={{ fontWeight: "bold" }} > <option value="">--Select--</option> <option value="100">TOP ACHIEVERS</option> <option value="75">ACHIEVERS</option> <option value="50">FAST MOVERS</option> <option value="25">ASPIRERS</option> </Field>
        ) : (
          <Field
            autoComplete="off"
            className="form-control"
            name={entryField}
          value={ fieldValue }
            onChange={formik.handleChange}
            onInput={(e) =>{
              if(indicator.unit_cat_id === 1){
                allowNumberswithMaxLengthcatidtypeOnly(e, maxLen, "numeric", 3);
              }
              else{
allowNumberswithMaxLengthtypeOnly(e, maxLen, "numeric", 3)
              }
            }
              
            }
            onBlur={(e) => {
 
  handleInputChange(e, formikIndex,entryField,"District"); formik.handleChange(e); }}
            type="text"
            style={{ textAlign: "right" }}
            // (formik.values.DistIndicators[formikIndex]?.ind_type === "N" && formik.values.DistIndicators[formikIndex]?.status_id !== 4)? false: 
         disabled={
  isDisabled
}

             {...indicator.unit_cat_id === 1 ? 
                restrictToPasteOnlyEightDotcommaThreeAllowKeyPress( formik, "District", entryField, formikIndex )
            :restrictToPasteOnlyEightDotThreeAllowKeyPress( formik, "District", entryField, formikIndex )}

          />
        )}
      </td>
    </React.Fragment>
  );
})}

               
            </tr>
          );
        })
    )}
  </tbody>
</table>

                        </div>
                        </div>
                        {statusId !== 4 && 
  <div style={{ textAlign: "center", backgroundColor: "#4e835c" }} className="rounded-1 border py-2 px-2 mb-3 " > 
                 
 <div className="text-center style-1">
   {buttonenb && <> <Button variant="success" className="save me-4" size="sm"  type="button" onClick={() => SaveDistEntryData('District')} > Save <FaRegSave className="ms-1 s-icon" /> </Button></>}
        </div>
 </div>
}
                        {(statusId !== 4 && roleid !== "8") &&
                         <div className="warning-box d-flex ">
                                                        <Field type="checkbox" name="checked" id="custom-checkbox" onChange={handleCheckforward} checked={isbuttonChecked} className="me-4 check-box-width" style={{ transform: 'scale(1.8)' }} />
                                                        <p>
                                                          Please review the data carefully before submitting. Once submitted, no further changes can be made, and the data will be forwarded for scrutiny as final.
                                                        </p>
                                                        <img src="images/warning.webp" alt="warning" className="img-fluid" />
                                                      </div>}
                       {statusId !== 4&&<>
                        <div className="bottom-buttons d-flex justify-content-center mt-4 mb-5">
                     {buttonenb && <>
                     
     {roleid != "8" &&
        <Button variant="" size="sm" className="next-btn me-4" type="button" onClick={() =>{ distupdateData('District')}} > Submit&Freeze <FaRegSave className="ms-1 s-icon" /> </Button>
     }
       </> 
}
    </div>
    </>}
                  
</Col>

              </Row>
 }
  {container && ( <>
         
         
            <Row className="w-100 justify-content-center mt-4 mb-3"> <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={12}> <Alert severity="warning" icon={<FaExclamationTriangle className="blinking-icon" />} sx={{ fontSize: "16px", padding: "40px 32px", borderRadius: "8px", backgroundColor: "#fff3cd", color: "#856404", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", }} >
            District Level Indicators Not Available </Alert> </Col> </Row> 
            </> )} 

                      </Tab.Pane>
                     } 


                  </Tab.Content>

                </Col>




               

              </Row>
            </Tab.Container>
}
{(roleid === "32" || roleid === "2"|| (roleid === "8" && menuEntry === "Mandal Targets Entry")) &&<>
      <Container fluid className="px-2 py-3">
        {(!container &&Entryenb)&&<>
              <Row>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">
<Row>
                      
                                                   
                                                                    
                                                                     <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                                                                                                               <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }}
                                                                                                                 onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }}
                                                                                                                 onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }}
                                                                                                               >
                                                                                                                 <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText} onChange={(event) => setSearch(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                                                                                                               </div>
                                                                                                             </Col>
                                                                                                             <Col className=" mb-2 " >
                                                                                         
                                                                                         <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToentryExcel("my-table1",formik.values,"TargetsEntry")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                                                                                  
                                                   
                                                                                     </Col>
                                                                                     </Row>
                       




    
<div id="table-scroll" className={`table-scroll mt-2 ${statusId === 4 ? 'mb-5' : ''}`} >

            <div className="table-wrap">
                         
<table className="table table-bordered custom-table table-responsive sticky-table" id="my-table1">
 <thead>
  <tr className="text-center">
    <th rowSpan={2} className="sticky-col sticky-sno">Sl.No.</th> <th rowSpan={2} className="sticky-col sticky-INDICATOR indicator-cell">INDICATOR</th> <th rowSpan={2} className="sticky-col sticky-UNIT" style={{whiteSpace: "normal", wordWrap: "break-word", maxWidth: "90px",minWidth:"90px" }}>UNIT</th> <th rowSpan={2} className="sticky-col sticky-totaldist">Targets <br/> Fixed  <br />By HOD</th>

 
 {filteredMandals.map(d => (
      <th key={`name-${ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)? d.ulb_code:d.mandal_code}`} colSpan={1}>{ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)? d.ulb_name:d.mandal_name}</th>
    ))}
    <th rowSpan={2} className="sticky-col sticky-total">Total</th>
  </tr>
  <tr>
    
      {filteredMandals.map(d => (
      <React.Fragment key={`subhead-${ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)? d.ulb_code:d.mandal_code}`}> <th>TARGETS ({formik.values.year})</th> </React.Fragment>
    ))}
  </tr>
</thead>

<tbody>
  {filteredIndicators.length === 0 ? (

    <tr>
      <td className="text-center" colSpan={5 + mandals.length * 2}>
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
      filteredIndicators.map((indicator, i) => {
  const formikIndex = formik.values.MandalIndicators.findIndex(
    (f) => f.indicator_id === indicator.indicator_id
  );
  return (
      <tr key={indicator.indicator_id || `row-${formikIndex}`}>
        <td className="text-center sticky-col sticky-sno">{formikIndex + 1}</td>
        <td className="sticky-col sticky-INDICATOR indicator-column">
           {(indicator.ind_type === "N" && statusId !== 4 && indicator.status_id !== 4 ) &&
                                      <img src="../images/new3.gif" width="20px" alt="new" style={{ marginRight: "5px" }} />
                                      }{indicator.indicator_name || ""}
          
        </td>
        <td className="sticky-col sticky-UNIT " style={{ whiteSpace: "normal", wordWrap: "break-word", maxWidth: "90px" ,minWidth:"90px"}}>{indicator.unit_name || ""}</td>
        <td className="sticky-col sticky-totaldist text-right" style={{ zIndex:2}}>{indicator.unit_cat_id === 1 ? formatNumberIndianWithDecimal(indicator.district_target_2025 ) : indicator.district_target_2025 }</td>
        {filteredMandals.map((mandal) => {
          const code =ulbdeptlist.includes(roleid === "8"? formik.values.department_id:deptId)? mandal.ulb_code:mandal.mandal_code
          const fieldName = `MandalIndicators[${formikIndex}].entry_${code}`;
          const fieldValue = indicator.unit_cat_id === 1 ? formatNumberIndianWithDecimal(formik.values.MandalIndicators?.[formikIndex]?.[`entry_${code}`]):formik.values.MandalIndicators?.[formikIndex]?.[`entry_${code}`] ;
          // const isDisabled = statusId === 4;
const rowStatusId = formik.values.MandalIndicators[formikIndex]?.status_id;

const indType = formik.values.MandalIndicators[formikIndex]?.ind_type;

const isDisabled =
  rowStatusId === 4 || (indType === "O" && statuscheck === 4);
          return (
            <React.Fragment key={`cell-${code}`}>

             
              <td className="text-end">
 <Field
  className="form-control"
  name={fieldName}
  value={fieldValue}
  type="text"
  onChange={(e) => { let val = e.target.value; formik.setFieldValue(fieldName, val); }}
  onInput={(e) => {
    if (indicator.unit_cat_id === 1) { allowNumberswithMaxLengthcatidtypeOnly(e, maxLen, "numeric", 3); } 
    else { allowNumberswithMaxLengthtypeOnly(e, maxLen, "numeric", 3); }
  }}
  onBlur={(e) => { handleInputChange(e, formikIndex, fieldName, "Mandal"); }}

  disabled={isDisabled}
  style={{ textAlign: "right" }}
  {...(indicator.unit_cat_id === 1
    ? restrictToPasteOnlyEightDotcommaThreeAllowKeyPress(formik, "District", fieldName, formikIndex)
    : restrictToPasteOnlyEightDotThreeAllowKeyPress(formik, "District", fieldName, formikIndex))}
/>

</td>

            </React.Fragment>
          );
        })}

        <td className="sticky-col sticky-total text-center">
          <Field type="text" name={`MandalIndicators[${formikIndex}].total`} value={indicator.unit_cat_id === 1 ? formatNumberIndianWithDecimal(formik.values.MandalIndicators[formikIndex].total) : formik.values.MandalIndicators[formikIndex].total} className="form-control" disabled style={{ minWidth: "120px", whiteSpace: "nowrap", zIndex: 2 ,textAlign:"right"}} />
        </td>
      </tr>
  );
})
)
}
  
</tbody>

</table>


                        </div>
                        </div>
                        {(statusId !== 4 && indicatorsList.length >0)&& 
  <div style={{ textAlign: "center", backgroundColor: "#4e835c" }} className=" mb-3" > 
                 
 <div className="text-center style-1">
   <Button variant="success" className="save me-4" size="sm"  type="button" onClick={() => SaveMandalEntryData('CPO')} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
        </div>
 </div>
}
                        {(statusId !== 4 && indicatorsList.length >0 && roleid !== "8") &&
                         <div className="warning-box d-flex "> <Field type="checkbox" name="checked" id="custom-checkbox" onChange={handleCheckforward} checked={isbuttonChecked} className="me-4 check-box-width" style={{ transform: 'scale(1.8)' }} />
                                                        <p>
                                                          Please review the data carefully before submitting. Once submitted, no further changes can be made, and the data will be forwarded for scrutiny as final.
                                                        </p>
                                                        <img src="images/warning.webp" alt="warning" className="img-fluid" />
                                                      </div>}
                        {(statusId !== 4 && indicatorsList.length >0)&&<>
                        <div className="bottom-buttons d-flex justify-content-center mt-4 mb-5">
     {roleid != "8" &&
        <Button variant="" size="sm" className="next-btn me-4" type="button" onClick={() =>{ distupdateData('CPO')}} > Submit&Freeze <FaRegSave className="ms-1 s-icon" /> </Button>
     }
      
    </div>
    </>}
                  
</Col>

              </Row>
</>}
  {container && ( <>
         
         
            <Row className="w-100 justify-content-center"> <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={12}> <Alert severity="warning" icon={<FaExclamationTriangle className="blinking-icon" />} sx={{ fontSize: "16px", padding: "40px 32px", borderRadius: "8px", backgroundColor: "#fff3cd", color: "#856404", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", }} >
            {alertenb ? "Mandal-level entry is not required as the targets has not been assigned by the HOD.":"Mandal-level entry is not required as no indicators have been assigned at the mandal level."} </Alert> </Col> </Row> 
            </> )} 
      </Container>

          
</>}

      </Form>
        </FormikProvider>
      </Container>
      <Modal fade={false} className="newmodal" aria-labelledby="contained-modal-title-vcenter" centered show={showModal} onHide={null} backdrop="static" keyboard={false} >
            <Modal.Header>
              <Modal.Title></Modal.Title>
              <span role="button" tabIndex={0} onClick={handleClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClose(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} style={{ fontSize: "30px", cursor: "pointer" }} className="me-1" > &#215; </span>

            </Modal.Header>
      
            <Modal.Body
                      className="p-3 d-flex flex-column justify-content-center align-items-center"
                      onKeyDown={handleKeyDown} 
                    >
                      <div className="text-center">
                        
                          <img src="images/question.gif" style={{ width: '70px', marginBottom: '10px' }} alt="Warning Icon" />
                        <p className="fw-bold" style={{ fontSize: '17px' }}> Are you sure you want to Proceed Once Submitted No More Changes Can be Done? </p>
                      </div>
                    </Modal.Body>
      
            <Modal.Footer>
                   
                      <button type="button" className="conform" onClick={()=>{buttontype === "District" && ["60","5"].includes(roleid)? multidistupdate():["32","2"].includes(roleid) ? multimandalupdate():handleConfirm()}}> Yes </button>
                      <button type="button" className="cancel" onClick={handleClose}> No </button>
                    </Modal.Footer>
          </Modal>
      <AlertModal
        show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert}
      />

    </>
  );
}


